import { LoiFormsProcessStep } from '../loi-comparison/models/loi-forms-process.model';

export interface LegalTabsAccessInput {
    isAdmin: boolean;
    isReadonly: boolean;
    isHistoricalVersion: boolean;
    isBuyerInactive: boolean;
    processStep: LoiFormsProcessStep | undefined;
    isInitialSubmission: boolean;
    isBuyerLoiFormReview: boolean;
    isBuyerReviewConfirmed: boolean;
    isFormComplete: boolean;
}

export function resolveLegalTabsReadonly(input: LegalTabsAccessInput): boolean {
    if (input.isAdmin) {
        return input.isReadonly
            || input.isHistoricalVersion
            || input.isBuyerInactive
            || input.processStep === undefined
            || input.processStep === LoiFormsProcessStep.BuyerSubmission;
    }
    if (input.isInitialSubmission) {
        return true;
    }
    if (input.isBuyerLoiFormReview) {
        return input.isBuyerReviewConfirmed;
    }
    return input.isReadonly || input.isFormComplete;
}
